import styled from 'styled-components'

import {media} from '../../../theme'

import '@ongov/ontario-design-system-design-tokens/dist/css/_variables.css'

export const BackToTop = styled.button`
  position: fixed;
  bottom: calc(5% + 68px);
  right: 2%;
  cursor: pointer;
  opacity: 1;
  z-index: 2;
  visibility: visible;
  display: flex;
  align-items: center;
  height: 3rem;
  font-family: var(--ontario-fonts-open-sans);
  padding: var(--ontario-spacing-2) var(--ontario-spacing-4)
    var(--ontario-spacing-2) var(--ontario-spacing-3);
  font-size: 1rem;
  font-weight: 600;
  transition: none;
  border-radius: 5px;
  border: 0.125rem solid var(--ontario-colour-greyscale-white);
  box-shadow: var(--ontario-spacing-0) 0.125rem var(--ontario-spacing-1)
    rgb(0 0 0 / 60%);
  box-sizing: border-box;

  &:hover {
    background-color: #ccc;
  }

  &:focus {
    background-color: #e6e6e6;
    box-shadow: 0 0 0 4px var(--ontario-colour-system-focus),
      0 3px 5px 3px rgba(0, 0, 0, 0.6);
    outline: 4px solid transparent;
    transition: box-shadow 0.1s ease-in-out;
  }

  &:active {
    background-color: #b2b2b2;
    box-shadow: 0 0 0 4px var(--ontario-colour-system-focus),
      0 5px 7px 3px rgba(0, 0, 0, 0.6);
    outline: 4px solid transparent;
    transition: box-shadow 0.1s ease-in-out;
  }

  &:visited {
    color: var(--ontario-colour-greyscale-white);
  }

  @media ${media.xsmall} {
    display: block;
    padding: var(--ontario-spacing-2);
    font-size: 0;
    width: 3rem;
    height: 3rem;
  }

  @media ${media.small} {
    bottom: calc(5% + 100px);
    display: flex;
    flex-direction: column;
    height: 4.75rem;
    padding: 0.375rem var(--ontario-spacing-3) 0.5625rem
      var(--ontario-spacing-3);
    font-size: 1rem;
  }

  @media ${media.medium} {
    bottom: calc(5% + 68px);
    height: 3rem;
    width: auto;
    font-size: 1rem;
  }

  @media print {
    display: none;
  }
`

export const IconImage = styled.i`
  display: inline-block;
  background: url('./images/ontario-icon-arrow-up.svg');
  background-size: 100%;
  width: 2rem;
  height: 2rem;
  margin: 0.125rem var(--ontario-spacing-2) var(--ontario-spacing-0)
    var(--ontario-spacing-0);

  @media ${media.xsmall} {
    margin: 0;
  }

  @media ${media.small} {
    margin: 0.0625rem var(--ontario-spacing-0) var(--ontario-spacing-0)
      var(--ontario-spacing-1);
  }

  @media ${media.medium} {
    margin: 0.125rem var(--ontario-spacing-2) var(--ontario-spacing-0)
      var(--ontario-spacing-0);
  }
`

export const ButtonTextContainer = styled.span`
  display: flex;
  align-items: center;
  font-weight: var(--ontario-font-weights-normal);

  @media ${media.small} {
    display: block;
  }

  @media ${media.medium} {
    display: flex;
  }
`
